var Acr = Acr || {};

Acr.Drawer = function () {

  var $element;
  var hash;
  const drawerSection = '.js-drawer-section';
  const drawerBody = '.js-drawer-body';
  const drawerLink = '.js-drawer-link';
  const drawerIconMinus = '.js-drawer-icon-minus';
  const drawerIconPlus = '.js-drawer-icon-plus';


  function openDrawer(target) {

    var drawerElements;

    drawerElements = [].slice.call(target);

    drawerElements.forEach(function (drawerElement) {

      var $drawerElement;

      $drawerElement = $(drawerElement);

      $drawerElement.removeClass('acr-drawer__section--collapsed');

      $drawerElement.find(drawerBody)
        .slideDown()
        .removeClass('acr-drawer__body--collapsed');

      $drawerElement.find(drawerIconMinus).css('display', 'block');
      $drawerElement.find(drawerIconPlus).css('display', 'none');
      $drawerElement.find(drawerLink).attr('aria-expanded', 'true');
    });
  }

  function closeDrawer(target, noCloseId) {

    var drawerElements;

    drawerElements = [].slice.call(target);

    drawerElements.forEach(function (drawerElement) {

      var $drawerElement;

      $drawerElement = $(drawerElement);

      if (noCloseId !== '#' + $drawerElement.find(drawerBody).attr('id')) {

        $drawerElement.addClass('acr-drawer__section--collapsed');

        $drawerElement.find(drawerBody)
          .slideUp()
          .addClass('acr-drawer__body--collapsed');

        $drawerElement.find(drawerIconMinus).css('display', 'none');
        $drawerElement.find(drawerIconPlus).css('display', 'block');
        $drawerElement.find(drawerLink).attr('aria-expanded', 'false');

      }

    });

  }

  function onClickDrawer() {
    $element.find(drawerLink).on('click', function (e) {
      var target = $(this).closest(drawerSection);

      e.preventDefault();

      if (target.hasClass('acr-drawer__section--collapsed')) {
        openDrawer(target);
      } else {
        closeDrawer(target);
      }
    });
  }

  function initSelectors(element) {
    $element = $(element);
    hash = window.location.hash;
  }

  function bindEvents(element) {
    initSelectors(element);
    onClickDrawer();
    closeDrawer($element.find(drawerSection), hash);
  }

  function init(element) {
    bindEvents(element);
  }

  return {
    init: init,
  };

};
